import React, {Component} from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import StockOrderWithHistoryModal from '../Shared/StockOrderWithHistoryModal';

const propTypes = {
        "buttonText": PropTypes.string,
        "className": PropTypes.string,
        "id": PropTypes.string
    },

    defaultProps = {
        "id": "button-download-as-xlsx",
        "className": "button-download",
        "buttonText": "Print Options"
    };

export default class StockOrderPrintOption extends Component {

    constructor (props) {

        super(props);
        this.state = {
            printWithHistory: false
        };
    }

    render() {
        
        const
            popover =
                (<Popover>
                    <Popover.Body>
                        <div style={{padding: "0 10px"}}>
                            <h6 className="text-center">{this.props.pageText.stockOrderPrintOrderBtn}</h6>
                            <Button variant="outline-secondary" className="mr-2 buttonText" onClick={() => { document.body.click(), this.props.print() }}>
                                {this.props.pageText.stockOrderPrintBtn}
                            </Button>
                            <Button variant="outline-secondary" className="mr-2 buttonText" onClick={() => { document.body.click(), this.setState({ printWithHistory: true })}} data-toggle='modal' data-target='#stockOrderWithHistoryModal'>
                                {this.props.pageText.stockOrderPrintWithHistoryBtn}
                            </Button>
                        </div>
                    </Popover.Body>
                </Popover>)
            ;

        return (
            <>
                <OverlayTrigger
                    key="printoption"
                    overlay={popover}
                    placement="bottom"
                    trigger="click"
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: true
                            }
                        }
                    }}
                    rootClose={true}
                >
                    {this.props.extarnalProp ? 
                        this.props.extarnalProp
                        :
                    <i
                        className="material-icons download"
                        id={this.props.id}
                        title={this.props.tooltip}
                    >
                        get_app
                    </i>}
                </OverlayTrigger>

                <StockOrderWithHistoryModal
                    isStockOrderUpdated={this.props.isStockOrderUpdated}
                    onStockOrderWithHistoryRefreshed={this.props.onStockOrderWithHistoryRefreshed}
                    pageText={this.props.pageText}
                    sessionInfo={this.props.sessionInfo}
                    inventoryPK={this.props.inventoryPK}
                    orderTypePK={this.props.orderTypePK}
                    printWithHistory={this.state.printWithHistory}
                    onHide={() => this.setState({
                        printWithHistory: false
                    })}
                />

            </>
        );

    }

}

StockOrderPrintOption.propTypes = propTypes;
StockOrderPrintOption.defaultProps = defaultProps;
